// Theme Compatibility Component Animation
document.addEventListener('DOMContentLoaded', function() {
    const progressFill = document.querySelector('.progress-fill');
    const scoreNumber = document.querySelector('.score-number');
    
    if (!progressFill || !scoreNumber) return;
    
    // Initialize progress bar to 0% immediately
    progressFill.style.width = '0%';
    progressFill.style.transition = 'none'; // Disable transition initially
    
    // Create intersection observer to trigger animation when component is visible
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateProgress();
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.5
    });
    
    // Observe the theme compatibility component
    const themeCompatibility = document.querySelector('.theme-compatibility');
    if (themeCompatibility) {
        observer.observe(themeCompatibility);
    }
    
    function animateProgress() {
        const targetScore = parseInt(progressFill.dataset.score) || 100;
        
        // Ensure progress bar starts at 0%
        progressFill.style.width = '0%';
        progressFill.style.transition = 'none';
        
        // Force a reflow to ensure the 0% width is applied
        progressFill.offsetHeight;
        
        // Enable transition and animate to target
        setTimeout(() => {
            progressFill.style.transition = 'width 1s ease-out';
            progressFill.style.width = targetScore + '%';
        }, 50);
        
        // Animate score counter
        animateCounter(scoreNumber, 0, targetScore, 1000);
    }
    
    function animateCounter(element, start, end, duration) {
        const startTime = performance.now();
        
        function updateCounter(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            
            // Easing function for smooth animation
            const easeOutQuart = 1 - Math.pow(1 - progress, 4);
            const currentValue = Math.round(start + (end - start) * easeOutQuart);
            
            element.textContent = currentValue;
            
            if (progress < 1) {
                requestAnimationFrame(updateCounter);
            }
        }
        
        requestAnimationFrame(updateCounter);
    }
}); 